module.exports = __webpack_public_path__ + "img/9788971969823.c1d593a1.jpg";